export enum DialogType{
    CONFIRM,
    ERROR,
    CONFIRM_WITH_INPUT
}